'use strict';

export default class Search {
  constructor(options) {
    console.log('Search module');

    let carousel, carouselSpeed = null;

    if (Drupal.settings.hasOwnProperty('carousel')) {
      carousel = Drupal.settings.carousel.hasOwnProperty('current') ? Drupal.settings.carousel.current : Drupal.settings.carousel.common;
      carouselSpeed = Drupal.settings.carousel.hasOwnProperty('speed') ? Drupal.settings.carousel.speed : 5000;
    }

    const defaults = {
      wrapper: '.search',
      carousel: carousel,
      carouselSpeed: carouselSpeed,
      acInputs: '.search input[type="text"]',
      submitButton: '.search .form-submit'
    };

    this.options = Object.assign({}, defaults, options);
    this.ac = [];
    this.searchType = null;
    this.searchValue = null;
    this.indexBg = 1;

    //auto init
    this._applyAutoComplete();
    this._listemButtonClick();
    this._listemForm();
    this._initCarousel();
  }

  _pacSelectFirst(input) {
    // store the original event binding function
    var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

    function addEventListenerWrapper(type, listener) {
      // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
      // and then trigger the original listener.
      if (type == "keydown") {
        var orig_listener = listener;
        listener = function (event) {
          var suggestion_selected = $(".pac-item-selected").length > 0;
          if (event.which == 13 && !suggestion_selected) {
            var simulated_downarrow = $.Event("keydown", {
              keyCode: 40,
              which: 40
            });
            orig_listener.apply(input, [simulated_downarrow]);
          }

          orig_listener.apply(input, [event]);
        };
      }

      _addEventListener.apply(input, [type, listener]);
    }

    input.addEventListener = addEventListenerWrapper;
    input.attachEvent = addEventListenerWrapper;
  }

  _applyAutoComplete() {

    let acOptions = {
      componentRestrictions: { country: "fr" }
    };

    this.ac = [];

    $.each($(this.options.acInputs), function (i, elem) {

      this._pacSelectFirst(elem);

      this.ac[elem.id] = {};

      elem.addEventListener('input', function (event) {
        if ((Object.entries(this.ac[event.target.id]).length === 0 && this.ac[event.target.id].constructor === Object) && (event.target.value.length >= 3)) {
          this.ac[event.target.id].autocomplete = new google.maps.places.Autocomplete(document.getElementById(event.target.id), this.acOptions);
          this.ac[event.target.id].inputId = elem.id;

          this.ac[event.target.id].autocompleteLsr = google.maps.event.addListener(this.ac[event.target.id].autocomplete, 'place_changed', function () {
            this.searchValue = $(elem).val();
            this.searchType = $(elem).attr('name');
            this._changeUrl();

            // Récupération des noms des départements provenant de la home page du menu des départements
            $(".select__elem[name=Departement] option").each(function (index, value) {

              // on récupere tous les départements et leur id
              var optionValues = value.value;

              // Pour chaque département récupéré, on recupere que le nom du département
              var depName = optionValues.substr(0, (optionValues.length - 3));

              // Pour chaque département récupéré, on récupère l'id département
              var idDep = optionValues.substring(optionValues.length, optionValues.length - 3)

              // Pour chaque id de département, on garde que le numéro de département
              var numDep = idDep.slice(-2);

              // On récupére la valeur de recherche où l'on retire le ', France'
              var rechercheValue = $(elem).val();
              rechercheValue = rechercheValue.substr(0, (rechercheValue.length - 8));

              // Retrait des accents et des apostrophes
              rechercheValue = rechercheValue.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
              rechercheValue = rechercheValue.replace("'", '');

              // en fonction du match, l'url :
              if ((rechercheValue.toLowerCase() == depName.toLowerCase()) || (rechercheValue == numDep)) {
                this._changeUrlDepartement(depName, idDep);
              }

            }.bind(this));

          }.bind(this));

          setTimeout(function () {
            google.maps.event.trigger(document.getElementById(event.target.id), 'keydown', { keyCode: 39 });
          }.bind(this), 200);
        }
        else if ((Object.entries(this.ac[event.target.id]).length !== 0 && this.ac[event.target.id].constructor === Object) && (event.target.value.length <= 2)) {
          google.maps.event.removeListener(this.ac[event.target.id].autocompleteLsr);
          google.maps.event.clearInstanceListeners(document.getElementById(event.target.id));
          $(".pac-container").remove();
          this.ac[event.target.id] = {};
        }
      }.bind(this));

    }.bind(this));
  }

  _listemForm() {
    $.each($(this.options.acInputs), function (i, elem) {
      $(elem).on('keyup change', function (evt) {
        this.searchValue = $(elem).val();
        this.searchType = $(elem).attr('name');
        this._changeUrl();
      }.bind(this));

    }.bind(this));
  }

  _listemButtonClick() {
    $(this.options.submitButton).on('click touchend', function (evt) {
      evt.preventDefault();
      if (typeof $(this).data('url') != "undefined") {
        var host = location.protocol + "//" + window.location.hostname + "/" + $(this).data('url');
        window.location.href = host;
      } else {
        $(this).prev('div').find('input').focus();
      }

    });
  }
  _initUrl(searchType) {
    switch (searchType) {
      case 'tous_search_string':
        return "tous/";
      case 'mr_search_string':
        return "maisons-de-retraite/";
      case 'rs_search_string':
        return "residence-seniors/";
      case 'ad_search_string':
        return "aide-a-domicile/";
    }
  }

  _changeUrl() {
    // http://domusvi.dev/recherche/residences_seniors/Paris
    // http://domusvi.dev/recherche/maisons_de_retraite/Paris
    // http://domusvi.dev/recherche/aide_a_domicile/Paris
    // http://domusvi.dev/recherche/EHPAD/Paris
    $(this.options.submitButton).data('url', 'recherche/' + this._initUrl(this.searchType) + this.searchValue);
  }



  _changeUrlDepartement(depName, depId) {
    $(this.options.submitButton).data('url', this._initUrl(this.searchType) + depName + depId);
  }

  _initCarousel() {
    if (this.options.carousel != void 0) {
      if (this.options.carousel.length > 1) {
        $(this.options.wrapper).css('background-image', 'url(' + this.options.carousel[this.indexBg] + ')');
        window.Drupal.settings.carousel.running = window.setInterval(() => this._carouselTransition(), this.options.carouselSpeed);
      } else {
        $(this.options.wrapper).css('background-image', 'url(' + this.options.carousel[0] + ')');
      }
    }
  }

  _carouselTransition() {
    $(this.options.wrapper).css('background-image', 'url(' + this.options.carousel[this.indexBg] + ')');
    if (this.indexBg >= (this.options.carousel.length - 1)) {
      this.indexBg = 0;
    }
    else {
      this.indexBg++;
    }
  }
}
